module.exports = "https://static.wmbcdn.com/uniweb/images/fe61ae710117824ce5ec88c839e375a4.svg";